import { Namespace, Translate, useTranslate } from "localization";
import { Button, Modal } from "minimum-ui/core";

import { useTimeoutProvider } from "./useTimeoutProvider";

export const TimeoutProvider = ({ children }: { children: any }) => {
  const { isOpen, onClose, onContinue, onLogout } = useTimeoutProvider();
  const { translate } = useTranslate(Namespace.AUTHENTICATION);

  return (
    <>
      {children}
      <Modal
        isOpen={isOpen}
        onDismiss={onClose}
        disableEscapeAndClickOutside
        title={translate("sessionTimeoutTitle")}
        noBorder
        content={
          <Translate
            i18nKey="sessionTimeoutMessage"
            namespace={Namespace.AUTHENTICATION}
          />
        }
        actions={
          <>
            <Button variant="text" onClick={onLogout}>
              {translate("logOutNow")}
            </Button>
            <Button onClick={onContinue}>{translate("continueSession")}</Button>
          </>
        }
      />
    </>
  );
};

export default TimeoutProvider;
